import { projectsTimeline } from '../../data/projectsTimeline';
import { siteContent } from '../../data/siteContent';
import Card from '../card/Card';

const TimelineOne = () => {
  return (
    <div className="row">
      {projectsTimeline.map((data, index) => {
        const bullets = (data.bullets || []).slice(0, 4);
        const stack = Array.isArray(data.stack)
          ? data.stack
          : data.stack
            ? [String(data.stack)]
            : [];

        const primaryLink = data.links?.length ? data.links[0] : null;
        const primaryLabel = String(primaryLink?.label || '')
          .toLowerCase()
          .includes('company')
          ? 'Company website'
          : 'Live website';

        const publicUrl = process.env.PUBLIC_URL || '';

        return (
          <div className="col-lg-6 col-12 mt--30" key={index}>
            <Card
              title={data.title}
              image={
                !!data.image ? (
                  <div className="thumbnail mb--20 timeline-project-thumbnail">
                    {!!primaryLink?.href ? (
                      <a
                        href={primaryLink.href}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={`${publicUrl}${data.image}`}
                          alt={data.title}
                          loading="lazy"
                          className="w-100 radius-small"
                        />
                      </a>
                    ) : (
                      <img
                        src={`${publicUrl}${data.image}`}
                        alt={data.title}
                        loading="lazy"
                        className="w-100 radius-small"
                      />
                    )}
                  </div>
                ) : null
              }
            >
              {!!data.role && (
                <small className="d-block color-gray mb--10">{data.role}</small>
              )}

              {!!stack.length && (
                <div className="mt--10">
                  {stack.map((tech, techIdx) => (
                    <span
                      key={`${tech}-${techIdx}`}
                      className="badge rounded-pill mr--10 mt--10"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              )}

              {!!data.summary && (
                <p className="description b1 color-gray mt--20 mb--0">
                  {data.summary}
                </p>
              )}

              {!!bullets.length && (
                <ul className="list-style--1 mt--20">
                  {bullets.map((bullet, bulletIdx) => (
                    <li key={bulletIdx}>{bullet}</li>
                  ))}
                </ul>
              )}

              <div className="read-morebtn mt--20">
                {!!primaryLink?.href && (
                  <a
                    className="btn-default btn-border mr--20 mt--20"
                    href={primaryLink.href}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span>{primaryLabel}</span>
                  </a>
                )}
                <a
                  className="btn-default btn-border mr--20 mt--20"
                  href={siteContent.links.calendly}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>Book a Call</span>
                </a>
              </div>
            </Card>
          </div>
        );
      })}
    </div>
  );
};

export default TimelineOne;
